import { z } from 'zod';
/** Ball colours and their point values. */
export const BALL_VALUES = {
    red: 1,
    yellow: 2,
    green: 3,
    brown: 4,
    blue: 5,
    pink: 6,
    black: 7,
};
export const BallColorSchema = z.enum([
    'red',
    'yellow',
    'green',
    'brown',
    'blue',
    'pink',
    'black',
]);
/** Clearance order once all reds are gone. */
export const CLEARANCE_ORDER = [
    'yellow',
    'green',
    'brown',
    'blue',
    'pink',
    'black',
];
export const COLORS = CLEARANCE_ORDER;
export const TOTAL_REDS = 15;
export const RED_COUNTS = [6, 10, 15];
export const RedCountSchema = z.union([z.literal(6), z.literal(10), z.literal(15)]);
/** Sum of all colour values (yellow..black) = 27. */
export const COLOR_POINTS_TOTAL = CLEARANCE_ORDER.reduce((sum, c) => sum + BALL_VALUES[c], 0);
export function ballValue(color) {
    return BALL_VALUES[color];
}
//# sourceMappingURL=balls.js.map